import type { LessonBlock } from "@shared/lessonBlocks";
import type { CheckResult } from "./CheckShell";
import { IntroBlockView, ExplainBlockView, ExampleBlockView, FlashcardsBlockView, SummaryBlockView } from "./blocks/DisplayBlocks";
import { QuestionBlockView } from "./blocks/QuestionBlockView";
import { SimulationBlockView } from "./blocks/SimulationBlockView";
import { SortBlockView } from "./blocks/SortBlockView";
import { OrderBlockView } from "./blocks/OrderBlockView";
import { MatchBlockView } from "./blocks/MatchBlockView";
import { ClozeBlockView } from "./blocks/ClozeBlockView";
import { TapWordBlockView } from "./blocks/TapWordBlockView";
import { NumberLineBlockView } from "./blocks/NumberLineBlockView";
import { FractionBlockView } from "./blocks/FractionBlockView";

interface Props {
  block: LessonBlock;
  onResult: (r: CheckResult) => void;
  alreadyDone?: CheckResult | null;
}

/** Registry: maps a block type to its component. Add new block types here. */
export function LessonBlockRenderer({ block, onResult, alreadyDone }: Props) {
  switch (block.type) {
    case "simulation": return <SimulationBlockView block={block} onResult={onResult} alreadyDone={alreadyDone} />;
    case "intro": return <IntroBlockView block={block} />;
    case "explain": return <ExplainBlockView block={block} />;
    case "example": return <ExampleBlockView block={block} />;
    case "flashcards": return <FlashcardsBlockView block={block} />;
    case "summary": return <SummaryBlockView block={block} />;
    case "question": return <QuestionBlockView block={block} onResult={onResult} alreadyDone={alreadyDone} />;
    case "sort": return <SortBlockView block={block} onResult={onResult} alreadyDone={alreadyDone} />;
    case "order": return <OrderBlockView block={block} onResult={onResult} alreadyDone={alreadyDone} />;
    case "match": return <MatchBlockView block={block} onResult={onResult} alreadyDone={alreadyDone} />;
    case "cloze": return <ClozeBlockView block={block} onResult={onResult} alreadyDone={alreadyDone} />;
    case "tapword": return <TapWordBlockView block={block} onResult={onResult} alreadyDone={alreadyDone} />;
    case "numberline": return <NumberLineBlockView block={block} onResult={onResult} alreadyDone={alreadyDone} />;
    case "fraction": return <FractionBlockView block={block} onResult={onResult} alreadyDone={alreadyDone} />;
    default: {
      const t = (block as { type?: string }).type;
      return <div className="rounded-xl border border-dashed p-4 text-sm text-muted-foreground">Unsupported block type: {t}</div>;
    }
  }
}
